import { Checkbox } from 'antd';
import { useRouter } from 'next/router';
import { useState } from 'react';

import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { submitScribe } from '@elem/Service/next-level-power';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import styles from './index.module.scss';
import { textTran, termsTran } from '../../../config/subscribe';

const CheckboxGroup = Checkbox.Group;

const SITE_ID: any = {
    eu: '4427',
    uk: '4430',
    de: '4425',
    fr: '4428',
    it: '4429',
    es: '4426',
};

const CONTACT_LIST_ID: any = {
    eu: '324184408',
    uk: '16182394',
    de: '236549250',
    fr: '1053269597',
    it: '1998934371',
    es: '1772671024',
};

// const PRODUCT_MAP: any = {
//     product_dp3: {
//         id: '7596',
//         type: 'multiple',
//         value: 27,
//         overwrite: false,
//     },
//     product_d3: {
//         id: '7596',
//         type: 'multiple',
//         value: 28,
//         overwrite: false,
//     },
//     product_r3: {
//         id: '7596',
//         type: 'multiple',
//         value: [29],
//         overwrite: false,
//     },
//     product_rapid: {
//         id: '7596',
//         type: 'multiple',
//         value: [30],
//         overwrite: false,
//     },
// };

const SelectProducts = ({ onChange, value }: any) => {
    const { t } = useLang('fourinone.teaser');
    const productOptions = [
        { value: 27, label: t('sign_up_select_product_1') },
        { value: 28, label: t('sign_up_select_product_2') },
        { value: 29, label: t('sign_up_select_product_3') },
        { value: 30, label: t('sign_up_select_product_4') },
    ];
    const handleCheckChange = (value: any) => {
        onChange && onChange(value);
    };
    return (
        <div className="select-product-box">
            <p className="select-product-title">{t('sign_up_select_tip')}</p>
            <CheckboxGroup value={value} onChange={handleCheckChange}>
                {productOptions.map((item, index) => (
                    <Checkbox key={index} value={item.value}>
                        {item.label}
                    </Checkbox>
                ))}
            </CheckboxGroup>
        </div>
    );
};

export default function SignUp() {
    const { t } = useLang('fourinone.teaser');
    const { locale }: any = useRouter();
    const [isShowOutTips, setIsShowOutTips] = useState(false);
    const [outTipsText, setOutTipsText] = useState('');
    const [outTipsType, setOutTipsType] = useState('error');
    const [products, setProducts] = useState([27, 28, 29, 30]);
    const handleProductChange = (value: any) => {
        setProducts(value);
        if (value && value.length) {
            setTipsHandle(false);
        } else {
            setTipsHandle(true);
        }
    };
    // 提示语显示
    const setTipsHandle = (flag: boolean) => {
        if (flag) {
            setOutTipsType('error');
            setIsShowOutTips(true);
            setOutTipsText(t('sign_up_select_error_tip'));
        } else {
            setIsShowOutTips(false);
            setOutTipsText('');
        }
    };
    // 点击提交
    const clickEmarsysHandle = (data: any, callback: any) => {
        if (products.length === 0) {
            setTipsHandle(true);
        }
        setTipsHandle(false);

        const finalData = {
            ...data,
            source: 'WEB_NEW_PRODUCT_SUB',
        };

        handleSubmit(finalData, callback);
        return true; //停止内部的接口
    };

    const handleSubmit = async (data: any, callback: any) => {
        try {
            const res = await submitScribe(locale, data, {
                sector_name: t.rich('sign_up_title', {
                    highlight1: (text: string) => text,
                    highlight2: (text: string) => text,
                }),
                entry_position: 3,
            });
            if (res?.code === '0') {
                setOutTipsType('success');
                setIsShowOutTips(true);
                setOutTipsText(t('sign_up_success_tip'));
                callback && callback('success');
            } else {
                setOutTipsType('error');
                setIsShowOutTips(true);
                setOutTipsText(res?.message);
                callback && callback('fail');
            }
        } catch (error: any) {
            setOutTipsType('error');
            setIsShowOutTips(true);
            setOutTipsText(error);
        }
    };

    const fields = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // subs_entrance
        {
            id: '9690',
            type: 'multiple',
            value: [12],
            overwrite: false,
        },
        // 产品字段
        {
            id: '7596',
            type: 'multiple',
            value: products,
            overwrite: false,
        },
    ];

    return (
        <div className={styles.SignUp}>
            <div className="sign-up-box">
                <div className="sign-up-wrapper">
                    <div className={`sign-up-item-bg`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724148407117/sign_bg.jpg" alt="sign-up-img" />
                    </div>
                    <div className={`sign-up-item-bg-pad`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724228709990/sign_bg_h5.jpg" alt="sign-up-img" />
                    </div>
                    <div className={`sign-up-item-bg-h5`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724228709990/sign_bg_h5.jpg" alt="sign-up-img" />
                    </div>

                    <div className={`sign-up-item-content sign-up-item-content-${outTipsType}`}>
                        {/* <div className="sign-up-icon">
                            <img src="https://websiteoss.ecoflow.com/upload/image/1721207158060/gift_icon.png" alt="sign up icon" />
                        </div> */}

                        <p className="sign-up-title">
                            {t.rich('sign_up_title', {
                                highlight1: (text: string) => <span className="highlight-1">{text}</span>,
                                highlight2: (text: string) => <span className="highlight-2">{text}</span>,
                            })}
                        </p>
                        <SelectProducts value={products} onChange={handleProductChange} />

                        <EfEmarsysEmail
                            isOpenOutTips={true}
                            isShowOutTips={isShowOutTips}
                            outTipsText={outTipsText}
                            onBeforeSendCallback={clickEmarsysHandle}
                            contactListId={CONTACT_LIST_ID[locale]}
                            fields={fields}
                            needTerms={true}
                            tipsObj={textTran[locale] || textTran.us}
                            termsHtml={termsTran[locale] || termsTran.us}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
